<template>
  <signin-layout>
    <div class="page-container">
      <div class="logo-container">
        <img class="logo" src="@/assets/amt-logo-white-h200.png" alt="">
      </div>
      
      <h1 class="heading-1 tw">Information Management System</h1>
      <div class="signin-form-container">
        <text-input class="mb1"
          type="text"
          name="Username"
          label="Username"
          v-model="form.username"
          :value="form.username"
          @blur="blurUsername"
          :error="$v.form.username.$error"
          errorMessage="Please enter your AMT username"></text-input>
        <text-input class="mb1"
          type="password"
          name="Password"
          label="Password"
          v-model="form.password"
          :value="form.password"
          @blur="blurPassword"
          :error="$v.form.password.$error"
          errorMessage="Please enter a password of at least 5 characters"></text-input>
        <div class="form-button">
          <button class="btn btn-green no-margin fill"
            :disabled="formInvalid"
            @click="handleSigninClick">
            Signin
          </button>
        </div>
      </div>
      
    </div>
  </signin-layout>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators"

import store from "@/store"
import router from "@/router"
import SigninLayout from "@/layouts/SigninLayout"
import TextInput from "@/components/forms/TextInput"

export default {
  name: "SigninPage",
  data() {
    return {
      form: {
        username: "",
        password: ""
      }
    }
  },
  computed: {
    errorMessage() {
      return this.$store.getters.getErrorMessage
    },
    formInvalid() {
      return this.$v.$invalid
    }
  },
  validations: {
    form: {
      username: { required, minLength: minLength(4) },
      password: { required, minLength: minLength(5) }
    }
  },
  beforeRouteEnter(to, from, next) {
    if (store.getters.getAccessToken) {
      return router.replace("/")
    }
    next()
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("clearAuthError")
    next()
  },
  created() {
    this.$emit("update:layout", SigninLayout)
  },
  methods: {
    blurUsername() {
      this.$v.form.username.$touch()
    },
    blurPassword() {
      this.$v.form.password.$touch()
    },
    handleSigninClick() {
      if (this.formInvalid) return
      this.$store.dispatch("login", {
        username: this.form.username,
        password: this.form.password,
        redirect: this.$route.query.redirect
      })
    }
  },
  components: {
    SigninLayout,
    TextInput
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  width: 100%;
  color: rgba(white, 0.9);
  display: flex;
  flex-direction: column;
  padding-top: $base-padding * 4;
  align-items: center;
  @include breakpoint(md) {
    padding-top: $base-padding * 10;
  }
}
.logo-container {
  
  @include breakpoint(md) {
    margin-bottom: $base-padding * 5;
  }
}
.logo {
  @include breakpoint(xs) {
    width: 250px;
  }
  @include breakpoint(md) {
    width: 615px;
  }
}

.signin-form-container {
  width: 100%;
  padding: $base-padding * 2;

  @include breakpoint(sm) {
    width: 400px;
  }
}
.form-button {
  width: 100%;
  text-align: right;
}
.tw {
  color: rgba(white, 0.9);
}
.mb1 {
  margin-bottom: $base-padding / 2;
}
</style>
